import { User, BarChart3, Shield } from "lucide-react"

export const LoginAd = () => {
    return (
      <div className="hidden md:flex w-1/3 items-center justify-center pl-8 pr-2">
        <div className="relative w-full h-[90vh] rounded-2xl overflow-hidden shadow-xl flex flex-col items-center justify-center text-left py-8 sm:py-10 md:py-12 lg:py-16">
          <img
            src="/images/Frame 2147225834.png"
            alt="Signup banner"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="relative z-10 flex flex-col h-full p-8 justify-center gap-2">
            <h2 className="text-2xl md:text-2xl lg:text-4xl font-semibold text-white mb-3 leading-tight drop-shadow-lg">
              Streamline Your HR Operations
            </h2>
            <p className="text-white text-md  mb-10 leading-relaxed drop-shadow-lg">
              Join thousands of companies using Tempered Talent to manage
              employees, track onboarding, and simplify HR processes.
            </p>

            <div className="space-y-4">
              <div className="flex gap-3">
                <div className="shrink-0 w-9 h-9 bg-white/20 backdrop-blur-sm rounded-4xl flex items-center justify-center">
                  <User className="text-white" size={18} />
                </div>
                <div>
                  <h3 className="text-white font-semibold text-base mb-0.5 drop-shadow">
                    Employee Management
                  </h3>
                  <p className="text-white/90 text-xs drop-shadow">
                    Easily onboard, track, and manage your workforce
                  </p>
                </div>
              </div>

              <div className="flex gap-3">
                <div className="shrink-0 w-9 h-9 bg-white/20 backdrop-blur-sm rounded-4xl flex items-center justify-center">
                  <BarChart3 className="text-white" size={18} />
                </div>
                <div>
                  <h3 className="text-white font-semibold text-base mb-0.5 drop-shadow">
                    Analytics & Reports
                  </h3>
                  <p className="text-white/90 text-xs drop-shadow">
                    Get insights into your HR metrics and performance
                  </p>
                </div>
              </div>

              <div className="flex gap-3">
                <div className="shrink-0 w-9 h-9 bg-white/20 backdrop-blur-sm rounded-4xl flex items-center justify-center">
                  <Shield className="text-white" size={18} />
                </div>
                <div>
                  <h3 className="text-white font-semibold text-base mb-0.5 drop-shadow">
                    Secure & Compliant
                  </h3>
                  <p className="text-white/90 text-xs drop-shadow">
                    Enterprise-grade security with compliance features
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}